export default "__VITE_ASSET__DVTbkLKf__"